export type RateSettingsField =
  | 'charge_rate_8hr'
  | 'charge_rate_12hr'
  | 'margin_percent_1099'
  | 'base_margin_percent_w2'
  | 'total_margin_percent_w2'
  | 'use_blended_rate'
  | 'payout_max_weekly_regular_hours'
  | 'payout_seventh_day_rule_enabled'
  | 'charge_max_weekly_regular_hours'
  | 'charge_seventh_day_rule_enabled'
  | 'blended_non_blended_settings'
  | 'margin_percent_w2_travel'
  | 'margin_percent_w2_tcv'
  | 'margin_w2_tcv_cents'
  | 'assignment_bonus_tier2_travel_amount_cents'
  | 'assignment_bonus_tier2_travel_amount_tcv_cents'
  | 'assignment_bonus_tier1_travel_amount_cents'
  | 'assignment_bonus_tier1_travel_amount_tcv_cents'
  | 'pro_rate';

export interface FieldVisibilityConfig {
  [resource: string]: {
    hiddenFields: RateSettingsField[];
  };
}

export const sources: {
  ten99: RateSettingsField[];
  'w2.local': RateSettingsField[];
  'w2.travel': RateSettingsField[];
} = {
  ten99: ['margin_percent_1099'],
  ['w2.local']: ['base_margin_percent_w2', 'total_margin_percent_w2'],
  ['w2.travel']: [
    'margin_percent_w2_travel',
    'margin_percent_w2_tcv',
    'margin_w2_tcv_cents',
    'assignment_bonus_tier2_travel_amount_cents',
    'assignment_bonus_tier2_travel_amount_tcv_cents',
    'assignment_bonus_tier1_travel_amount_cents',
    'assignment_bonus_tier1_travel_amount_tcv_cents',
  ],
};

const defaultNonPositionalHideFields: RateSettingsField[] = [
  'charge_rate_8hr',
  'charge_rate_12hr',
  'pro_rate',
  ...sources['ten99'],
  ...sources['w2.local'],
  ...sources['w2.travel'],
];

export const RATE_SETTINGS_FIELD_VISIBILITY: FieldVisibilityConfig = {
  StateRateSetting: {
    hiddenFields: ['use_blended_rate', ...defaultNonPositionalHideFields],
  },
  StatePositionRateSetting: {
    hiddenFields: [
      'use_blended_rate',
      'payout_max_weekly_regular_hours',
      'payout_seventh_day_rule_enabled',
      'charge_max_weekly_regular_hours',
      'charge_seventh_day_rule_enabled',
      'blended_non_blended_settings',
      'pro_rate',
    ],
  },
  StateLocationTypeRateSetting: {
    hiddenFields: ['use_blended_rate', ...defaultNonPositionalHideFields],
  },
  StateLocationTypePositionRateSetting: {
    hiddenFields: [
      'use_blended_rate',
      'payout_max_weekly_regular_hours',
      'payout_seventh_day_rule_enabled',
      'charge_max_weekly_regular_hours',
      'charge_seventh_day_rule_enabled',
      'blended_non_blended_settings',
      'pro_rate',
    ],
  },

  MarketRateSetting: {
    hiddenFields: ['use_blended_rate', ...defaultNonPositionalHideFields],
  },
  MarketPositionRateSetting: {
    hiddenFields: ['pro_rate'],
  },
  MarketLocationTypeRateSetting: {
    hiddenFields: ['use_blended_rate', ...defaultNonPositionalHideFields],
  },
  MarketLocationTypePositionRateSetting: {
    hiddenFields: ['use_blended_rate', 'pro_rate'],
  },

  LocationRateSetting: {
    hiddenFields: defaultNonPositionalHideFields,
  },

  AgencyLocationRateSetting: {
    hiddenFields: defaultNonPositionalHideFields,
  },
  AgencyLocationPositionRateSetting: {
    hiddenFields: ['pro_rate'],
  },
};

export const isFieldVisible = (field: RateSettingsField, source: string): boolean => {
  const config = RATE_SETTINGS_FIELD_VISIBILITY[source];
  if (!config) {
    return true;
  }

  return !config.hiddenFields.includes(field);
};
